// // import React, { useState } from "react";
// // import {
// //   AppBar,
// //   Toolbar,
// //   Typography,
// //   Button,
// //   IconButton,
// //   Box,
// //   Container,
// //   Drawer,
// //   List,
// //   ListItem,
// //   useTheme,
// //   useMediaQuery,
// // } from "@mui/material";
// // import MenuIcon from "@mui/icons-material/Menu";
// // import CloseIcon from "@mui/icons-material/Close";
// // import ShopIcon from "@mui/icons-material/Shop"; 
// // // react-scroll मधून Link इम्पोर्ट केली
// // import { Link as ScrollLink } from "react-scroll"; 

// // // तुझ्या इमेजमधील लोगोचा पाथ इथे टाक
// // import LogoImg from "../images/logo1.jpg"; 

// // const Navbar = () => {
// //   const [mobileOpen, setMobileOpen] = useState(false);
// //   const theme = useTheme();
// //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

// //   // App.js मधील ID सोबत मॅच होणारे नाव
// //   const navItems = [
// //     { label: "मुख्य", to: "home" },
// //     { label: "आमच्या विषयी", to: "about" },
// //     { label: "सेवा", to: "services" },
// //     { label: "संगीत संग्रह", to: "music" },
// //     { label: "उत्पादने", to: "products" },
// //     { label: "संपर्क", to: "contact" },
// //   ];

// //   const handleDrawerToggle = () => {
// //     setMobileOpen(!mobileOpen);
// //   };

// //   return (
// //     <>
// //       <AppBar
// //         position="sticky"
// //         elevation={0}
// //         sx={{
// //           background: "linear-gradient(90deg, #d34715 0%, #e65100 50%, #f57c00 100%)",
// //           borderBottom: "1px solid rgba(255,255,255,0.1)",
// //         }}
// //       >
// //         <Container maxWidth="xl">
// //           <Toolbar disableGutters sx={{ py: 1 }}>
// //             {/* ── Logo & Title ── */}
// //             <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
// //               <Box
// //                 component="img"
// //                 src={LogoImg}
// //                 alt="Logo"
// //                 sx={{
// //                   height: { xs: 45, md: 55 },
// //                   width: { xs: 45, md: 55 },
// //                   borderRadius: "50%",
// //                   backgroundColor: "#fff",
// //                   p: 0.5,
// //                   mr: 1.5,
// //                 }}
// //               />
// //               <Box>
// //                 <Typography
// //                   variant="h6"
// //                   sx={{
// //                     fontWeight: 800,
// //                     lineHeight: 1.2,
// //                     color: "#fff",
// //                     fontSize: { xs: "1.1rem", md: "1.4rem" },
// //                   }}
// //                 >
// //                   स्वरसागरामृत परिवार
// //                 </Typography>
// //                 <Typography
// //                   variant="caption"
// //                   sx={{
// //                     display: { xs: "none", sm: "block" },
// //                     color: "rgba(255,255,255,0.9)",
// //                     fontWeight: 500,
// //                     fontSize: "0.75rem",
// //                   }}
// //                 >
// //                   दिगंबर जैन संगीत व पूजा विधान
// //                 </Typography>
// //               </Box>
// //             </Box>

// //             {/* ── Desktop Menu ── */}
// //             {!isMobile && (
// //               <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
// //                 {navItems.map((item) => (
// //                   <Button
// //                     key={item.label}
// //                     component={ScrollLink}
// //                     to={item.to}
// //                     spy={true}
// //                     smooth={true}
// //                     offset={-70}
// //                     duration={500}
// //                     sx={{
// //                       color: "#fff",
// //                       textTransform: "none",
// //                       fontSize: "0.9rem",
// //                       fontWeight: 500,
// //                       px: 1.5,
// //                       cursor: "pointer",
// //                       "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
// //                     }}
// //                   >
// //                     {item.label}
// //                   </Button>
// //                 ))}
                
// //                 {/* ── App Download Button (Desktop) ── */}
// //                 <Button
// //                   variant="contained"
// //                   component="a"
// //                   href="/app/SwarSagarAmrutApp(03-03-2026).apk" // तुझी फाईल लिंक
// //                   download="SwarSagarAmrut.apk" // डाउनलोड होताना फाईलला मिळणारे नाव
// //                   size="small"
// //                   startIcon={<ShopIcon sx={{ fontSize: '1rem !important' }} />}
// //                   sx={{
// //                     ml: 1,
// //                     backgroundColor: "#fff",
// //                     color: "#e65100",
// //                     borderRadius: "18px",
// //                     fontWeight: 700,
// //                     textTransform: "none",
// //                     fontSize: "0.85rem",
// //                     px: 2,
// //                     boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
// //                     "&:hover": { 
// //                       backgroundColor: "#f5f5f5",
// //                       boxShadow: "0 4px 12px rgba(0,0,0,0.25)"
// //                     },
// //                   }}
// //                 >
// //                   Download App
// //                 </Button>
// //               </Box>
// //             )}

// //             {/* ── Mobile Menu Icon ── */}
// //             {isMobile && (
// //               <IconButton color="inherit" onClick={handleDrawerToggle}>
// //                 <MenuIcon sx={{ fontSize: 30 }} />
// //               </IconButton>
// //             )}
// //           </Toolbar>
// //         </Container>
// //       </AppBar>

// //       {/* ── Mobile Drawer ── */}
// //       <Drawer
// //         anchor="right"
// //         open={mobileOpen}
// //         onClose={handleDrawerToggle}
// //         PaperProps={{
// //           sx: { width: "70%", background: "#fff" },
// //         }}
// //       >
// //         <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end" }}>
// //           <IconButton onClick={handleDrawerToggle}>
// //             <CloseIcon color="primary" />
// //           </IconButton>
// //         </Box>
// //         <List sx={{ pt: 0 }}>
// //           {navItems.map((item) => (
// //             <ListItem key={item.label} disablePadding>
// //               <Box
// //                 component={ScrollLink}
// //                 to={item.to}
// //                 spy={false}
// //                 smooth={true}
// //                 offset={-70}
// //                 duration={500}
// //                 onClick={handleDrawerToggle}
// //                 sx={{
// //                   width: "100%",
// //                   px: 3,
// //                   py: 1.2,
// //                   cursor: "pointer",
// //                   display: "block",
// //                   textDecoration: "none",
// //                   "&:hover": { backgroundColor: "#f5f5f5" }
// //                 }}
// //               >
// //                 <Typography sx={{ fontWeight: 600, color: "#333", fontSize: "0.95rem" }}>
// //                   {item.label}
// //                 </Typography>
// //               </Box>
// //             </ListItem>
// //           ))}
// //           <Box sx={{ p: 2 }}>
// //             {/* ── App Download Button (Mobile) ── */}
// //             <Button
// //               fullWidth
// //               variant="contained"
// //               component="a"
// //               href="/apk/SwarSagarAmrutApp(03-03-2026).apk" // तुझी फाईल लिंक
// //               download="SwarSagarAmrut.apk"
// //               size="small"
// //               startIcon={<ShopIcon />}
// //               sx={{ 
// //                 backgroundColor: "#fff",
// //                 color: "#e65100",
// //                 border: "1px solid #e65100",
// //                 borderRadius: "8px",
// //                 fontWeight: 700,
// //                 textTransform: "none",
// //                 py: 1,
// //                 "&:hover": { backgroundColor: "#f9f9f9" }
// //               }}
// //             >
// //               App Download
// //             </Button>
// //           </Box>
// //         </List>
// //       </Drawer>
// //     </>
// //   );
// // };

// // export default Navbar;

// import React, { useState } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   Button,
//   IconButton,
//   Box,
//   Container,
//   Drawer,
//   List,
//   ListItem,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import CloseIcon from "@mui/icons-material/Close";
// import ShopIcon from "@mui/icons-material/Shop"; 
// import { Link as ScrollLink, scroller } from "react-scroll"; 
// import { useNavigate, useLocation } from "react-router-dom";

// import LogoImg from "../images/logo1.jpg"; 

// const Navbar = () => {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   const navigate = useNavigate();
//   const location = useLocation();

//   const navItems = [
//     { label: "मुख्य", to: "home" },
//     { label: "आमच्या विषयी", to: "about" },
//     { label: "सेवा", to: "services" },
//     { label: "संगीत संग्रह", to: "music" },
//     { label: "उत्पादने", to: "products" },
//     { label: "संपर्क", to: "contact" },
//   ];

//   const handleDrawerToggle = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   const handleNavClick = (to) => {
//     if (location.pathname !== "/") {
//       navigate("/");
//       setTimeout(() => {
//         scroller.scrollTo(to, {
//           smooth: true,
//           duration: 500,
//           offset: -70,
//         });
//       }, 150);
//     }
//     if (mobileOpen) setMobileOpen(false);
//   };

//   return (
//     <>
//       <AppBar
//         position="sticky"
//         elevation={0}
//         sx={{
//           background: "linear-gradient(90deg, #d34715 0%, #e65100 50%, #f57c00 100%)",
//           borderBottom: "1px solid rgba(255,255,255,0.1)",
//         }}
//       >
//         <Container maxWidth="xl">
//           <Toolbar disableGutters sx={{ py: 1 }}>
//             {/* Logo Section */}
//             <Box 
//               sx={{ display: "flex", alignItems: "center", flexGrow: 1, cursor: 'pointer' }}
//               onClick={() => navigate("/")}
//             >
//               <Box
//                 component="img"
//                 src={LogoImg}
//                 alt="Logo"
//                 sx={{
//                   height: { xs: 45, md: 55 },
//                   width: { xs: 45, md: 55 },
//                   borderRadius: "50%",
//                   backgroundColor: "#fff",
//                   p: 0.5,
//                   mr: 1.5,
//                 }}
//               />
//               <Box>
//                 <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.2, color: "#fff", fontSize: { xs: "1.1rem", md: "1.4rem" } }}>
//                   स्वरसागरामृत परिवार
//                 </Typography>
//                 <Typography variant="caption" sx={{ display: { xs: "none", sm: "block" }, color: "rgba(255,255,255,0.9)", fontWeight: 500, fontSize: "0.75rem" }}>
//                   दिगंबर जैन संगीत व पूजा विधान
//                 </Typography>
//               </Box>
//             </Box>

//             {/* Desktop Menu */}
//             {!isMobile && (
//               <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                 {navItems.map((item) => (
//                   <Button
//                     key={item.label}
//                     component={location.pathname === "/" ? ScrollLink : "button"}
//                     to={item.to}
//                     spy={true}
//                     smooth={true}
//                     offset={-70}
//                     duration={500}
//                     onClick={() => handleNavClick(item.to)}
//                     sx={{
//                       color: "#fff",
//                       textTransform: "none",
//                       fontSize: "0.9rem",
//                       fontWeight: 500,
//                       px: 1.5,
//                       cursor: "pointer",
//                       "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
//                     }}
//                   >
//                     {item.label}
//                   </Button>
//                 ))}
                
//                 {/* ── Download App Button (Desktop) ── */}
//                 <Button
//                   variant="contained"
//                   component="a"
//                   href="/app/SwarSagarAmrutApp(03-03-2026).apk" 
//                   download="SwarSagarAmrut.apk" 
//                   size="small"
//                   startIcon={<ShopIcon sx={{ fontSize: '1rem !important' }} />}
//                   sx={{
//                     ml: 1,
//                     backgroundColor: "#fff",
//                     color: "#e65100",
//                     borderRadius: "18px",
//                     fontWeight: 700,
//                     textTransform: "none",
//                     fontSize: "0.85rem",
//                     px: 2,
//                     boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                     "&:hover": { 
//                       backgroundColor: "#f5f5f5",
//                       boxShadow: "0 4px 12px rgba(0,0,0,0.25)"
//                     },
//                   }}
//                 >
//                   Download App
//                 </Button>
//               </Box>
//             )}

//             {isMobile && (
//               <IconButton color="inherit" onClick={handleDrawerToggle}>
//                 <MenuIcon sx={{ fontSize: 30 }} />
//               </IconButton>
//             )}
//           </Toolbar>
//         </Container>
//       </AppBar>

//       {/* Mobile Drawer */}
//       <Drawer
//         anchor="right"
//         open={mobileOpen}
//         onClose={handleDrawerToggle}
//         PaperProps={{
//           sx: { width: "70%", background: "#fff" },
//         }}
//       >
//         <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end" }}>
//           <IconButton onClick={handleDrawerToggle}>
//             <CloseIcon color="primary" />
//           </IconButton>
//         </Box>
//         <List sx={{ pt: 0 }}>
//           {navItems.map((item) => (
//             <ListItem key={item.label} disablePadding>
//               <Box
//                 onClick={() => handleNavClick(item.to)}
//                 sx={{
//                   width: "100%",
//                   px: 3,
//                   py: 1.2,
//                   cursor: "pointer",
//                   display: "block",
//                   "&:hover": { backgroundColor: "#f5f5f5" }
//                 }}
//               >
//                 <Typography sx={{ fontWeight: 600, color: "#333", fontSize: "0.95rem" }}>
//                   {item.label}
//                 </Typography>
//               </Box>
//             </ListItem>
//           ))}
//           <Box sx={{ p: 2 }}>
//             {/* ── Download App Button (Mobile) ── */}
//             <Button
//               fullWidth
//               variant="contained"
//               component="a"
//               href="/app/SwarSagarAmrutApp(03-03-2026).apk"
//               download="SwarSagarAmrut.apk"
//               size="small"
//               startIcon={<ShopIcon />}
//               sx={{ 
//                 backgroundColor: "#fff",
//                 color: "#e65100",
//                 border: "1px solid #e65100",
//                 borderRadius: "8px",
//                 fontWeight: 700,
//                 textTransform: "none",
//                 py: 1,
//                 "&:hover": { backgroundColor: "#f9f9f9" }
//               }}
//             >
//               App Download
//             </Button>
//           </Box>
//         </List>
//       </Drawer>
//     </>
//   );
// };

// export default Navbar; 


import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  Container,
  Drawer,
  List,
  ListItem,
  useTheme,
  useMediaQuery,
  Tooltip
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ShopIcon from "@mui/icons-material/ShopTwo"; 
import { Link as ScrollLink, scroller } from "react-scroll"; 
import { useNavigate, useLocation } from "react-router-dom";

import LogoImg from "../images/logo1.jpg"; 

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const navigate = useNavigate();
  const location = useLocation();

  // तुमच्या नवीन अचूक फाईल नेमनुसार पाथ सेट केला आहे
  const apkDownloadPath = "/apk/SwarSagarAmrutAppFinal.apk";

  const navItems = [
    { label: "मुख्य", to: "home" },
    { label: "आमच्या विषयी", to: "about" },
    { label: "सेवा", to: "services" },
    { label: "संगीत संग्रह", to: "music" },
    { label: "उत्पादने", to: "products" },
    { label: "संपर्क", to: "contact" },
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleNavClick = (to) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        scroller.scrollTo(to, {
          smooth: true,
          duration: 500,
          offset: -70,
        });
      }, 150);
    }
    if (mobileOpen) setMobileOpen(false);
  };

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          background: "linear-gradient(90deg, #d34715 0%, #e65100 50%, #f57c00 100%)",
          borderBottom: "1px solid rgba(255,255,255,0.1)",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ py: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            
            {/* Logo Section */}
            <Box 
              sx={{ display: "flex", alignItems: "center", cursor: 'pointer' }}
              onClick={() => navigate("/")}
            >
              <Box
                component="img"
                src={LogoImg}
                alt="Logo"
                sx={{
                  height: { xs: 45, md: 55 },
                  width: { xs: 45, md: 55 },
                  borderRadius: "50%",
                  backgroundColor: "#fff",
                  p: 0.5,
                  mr: 1.5,
                }}
              />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.2, color: "#fff", fontSize: { xs: "1.1rem", md: "1.4rem" } }}>
                  स्वरसागरामृत परिवार
                </Typography>
                <Typography variant="caption" sx={{ display: { xs: "none", sm: "block" }, color: "rgba(255,255,255,0.9)", fontWeight: 500, fontSize: "0.75rem" }}>
                  दिगंबर जैन संगीत व पूजा विधान
                </Typography>
              </Box>
            </Box>

            {/* Desktop Menu */}
            {!isMobile && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                {navItems.map((item) => (
                  <Button
                    key={item.label}
                    component={location.pathname === "/" ? ScrollLink : "button"}
                    to={item.to}
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                    onClick={() => handleNavClick(item.to)}
                    sx={{
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "0.9rem",
                      fontWeight: 500,
                      px: 1.5,
                      cursor: "pointer",
                      "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
                    }}
                  >
                    {item.label}
                  </Button>
                ))}
                
                {/* ── App Download Button (Desktop - होव्हरवर पांढराच रंग) ── */}
                <Tooltip title="Download APK" arrow placement="bottom">
                  <Button
                    variant="contained"
                    component="a"
                    href={apkDownloadPath} 
                    download="SwarSagarAmrutAppFinal.apk" 
                    size="small"
                    startIcon={<ShopIcon sx={{ fontSize: '1rem !important' }} />}
                    sx={{
                      ml: 1,
                      backgroundColor: "#fff",
                      color: "#e65100",
                      borderRadius: "30px", 
                      fontWeight: 700,
                      textTransform: "none",
                      fontSize: "0.85rem",
                      px: 2.5,
                      py: 0.8,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      "&:hover": { 
                        backgroundColor: "#fff", 
                        boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
                        transform: "scale(1.03)"
                      },
                      transition: "all 0.3s ease"
                    }}
                  >
                    Download App
                  </Button>
                </Tooltip>
              </Box>
            )}

            {/* Mobile Menu Icon */}
            {isMobile && (
              <IconButton color="inherit" onClick={handleDrawerToggle}>
                <MenuIcon sx={{ fontSize: 30 }} />
              </IconButton>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: { width: "280px", background: "#fff" },
        }}
      >
        <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end" }}>
          <IconButton onClick={handleDrawerToggle}>
            <CloseIcon color="primary" />
          </IconButton>
        </Box>
        <List sx={{ pt: 0, px: 2 }}>
          {navItems.map((item) => (
            <ListItem key={item.label} disablePadding sx={{ mb: 0.5 }}>
              <Box
                onClick={() => handleNavClick(item.to)}
                sx={{
                  width: "100%",
                  px: 3,
                  py: 1.2,
                  cursor: "pointer",
                  display: "block",
                  borderRadius: "8px",
                  "&:hover": { backgroundColor: "#f5f5f5" }
                }}
              >
                <Typography sx={{ fontWeight: 600, color: "#333", fontSize: "0.95rem", textAlign: "center" }}>
                  {item.label}
                </Typography>
              </Box>
            </ListItem>
          ))}
          
          <Box sx={{ mt: 2, px: 1 }}>
            {/* ── App Download Button (Mobile) ── */}
            <Button
              fullWidth
              variant="contained"
              component="a"
              href={apkDownloadPath} 
              download="SwarSagarAmrutAppFinal.apk"
              size="large"
              startIcon={<ShopIcon />}
              onClick={() => setMobileOpen(false)}
              sx={{ 
                backgroundColor: "#fff",
                color: "#e65100",
                border: "2px solid #e65100",
                borderRadius: "30px", 
                fontWeight: 800,
                textTransform: "none",
                py: 1,
                whiteSpace: "nowrap",
                "&:hover": { 
                  backgroundColor: "#fff", 
                  boxShadow: "0px 3px 10px rgba(230, 81, 0, 0.2)"
                }
              }}
            >
              Download App
            </Button>
          </Box>
        </List>
      </Drawer>
    </>
  );
};

export default Navbar;